import React, { useMemo, useState } from 'react'
import { Grid } from '@mui/material'
import PropTypes from 'prop-types'
import { IMPORT_FORMATS } from '../../../import/constants/JobFormat'
import { useDispatch } from 'react-redux'
import { push } from '@lagunovsky/redux-react-router'
import JobAction from '../../../import/actions/JobAction'
import Input from 'components/forms/Input'
import i18n from 'simple-react-i18n'
import PresentationCard from 'components/card/PresentationCard'
import { Calculate, FileDownload, FileUpload, NotificationsActive, MoreHoriz } from '@mui/icons-material'

const defaultSize = 60

const getThemeIcon = (type) => {
    switch (type) {
        case 'import':
            return <FileDownload sx={{ fontSize: defaultSize }} />
        case 'export':
            return <FileUpload sx={{ fontSize: defaultSize }} />
        case 'calcul':
            return <Calculate sx={{ fontSize: defaultSize }} />
        case 'alert':
            return <NotificationsActive sx={{ fontSize: defaultSize }} />
        default:
            return <MoreHoriz sx={{ fontSize: defaultSize }} />
    }
}

const AddOtherStep = ({
    typeJob,
}) => {
    const dispatch = useDispatch()
    const [search, setSearch] = useState('')
    const defined = ['import', 'export', 'calcul', 'alert']

    const jobUnspecify = IMPORT_FORMATS().filter(c =>!c.specify && (typeJob === 'notDefined'? !defined.includes(c.type): c.type === typeJob))

    const filteredJobs = useMemo(() => {
        const value = search.toLowerCase()

        return jobUnspecify.filter(job =>
            job.label.toLowerCase().includes(value),
        )
    }, [jobUnspecify, search])

    return (
        <Grid container justifyContent='center' spacing={3}>
            <Grid size={12}>
                <Input
                    title={i18n.search}
                    value={search}
                    onChange={setSearch}
                />
            </Grid>

            {filteredJobs.map((data, index) => (
                <Grid size={4} key={index}>
                    <PresentationCard
                        iconComponent={getThemeIcon(data.type)}
                        title={data.label}
                        description={data.description ?? null}
                        onClick={() => {
                            dispatch(JobAction.addJob({ jobType: data.value }, false)).then((j) => {
                                dispatch(push(`/import/${j.id}`))
                            })
                        }}
                    />
                </Grid>
            ))}
        </Grid>
    )
}

AddOtherStep.propTypes = {
    typeJob: PropTypes.string,
}

export default AddOtherStep